import { Paper, Text, Stack, Table, Group, Badge } from "@mantine/core";
import { IconTrendingUp, IconTrendingDown } from "@tabler/icons-react";

/**
 * Evolución mensual de leads: nuevos, convertidos, perdidos y conversión.
 */
export default function MonthlyEvolutionChart({ monthlyEvolution }) {
  if (!monthlyEvolution || monthlyEvolution.length === 0) return null;

  const totals = monthlyEvolution.reduce(
    (acc, m) => ({
      newLeads: acc.newLeads + m.newLeads,
      converted: acc.converted + m.converted,
      lost: acc.lost + m.lost,
    }),
    { newLeads: 0, converted: 0, lost: 0 }
  );

  return (
    <Paper shadow="sm" radius="md" p="md">
      <Stack gap="sm">
        <Group justify="space-between">
          <Text fw={600} size="lg">
            Evolución Mensual
          </Text>
          <Group gap="xs">
            <Badge variant="light" color="blue" size="sm">
              {totals.newLeads} leads
            </Badge>
            <Badge variant="light" color="green" size="sm">
              {totals.converted} convertidos
            </Badge>
          </Group>
        </Group>

        <Table striped highlightOnHover withTableBorder withColumnBorders>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Mes</Table.Th>
              <Table.Th style={{ textAlign: "center" }}>Nuevos</Table.Th>
              <Table.Th style={{ textAlign: "center" }}>Convertidos</Table.Th>
              <Table.Th style={{ textAlign: "center" }}>Perdidos</Table.Th>
              <Table.Th style={{ textAlign: "center" }}>Conversión</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {monthlyEvolution.map((m, idx) => {
              const prev = idx > 0 ? monthlyEvolution[idx - 1] : null;
              const convRate =
                m.newLeads > 0
                  ? Math.round((m.converted / m.newLeads) * 1000) / 10
                  : 0;
              const trending =
                prev && prev.newLeads > 0
                  ? m.newLeads > prev.newLeads
                    ? "up"
                    : m.newLeads < prev.newLeads
                    ? "down"
                    : "same"
                  : null;

              return (
                <Table.Tr key={m.month} style={{ opacity: m.newLeads === 0 ? 0.4 : 1 }}>
                  <Table.Td>
                    <Group gap={4} wrap="nowrap">
                      <Text size="sm" fw={500}>
                        {m.monthName}
                      </Text>
                      {trending === "up" && (
                        <IconTrendingUp size={14} color="var(--mantine-color-green-6)" />
                      )}
                      {trending === "down" && (
                        <IconTrendingDown size={14} color="var(--mantine-color-red-6)" />
                      )}
                    </Group>
                  </Table.Td>
                  <Table.Td style={{ textAlign: "center" }}>
                    <Text size="sm" fw={600}>{m.newLeads}</Text>
                  </Table.Td>
                  <Table.Td style={{ textAlign: "center" }}>
                    <Text size="sm" c="green" fw={600}>{m.converted}</Text>
                  </Table.Td>
                  <Table.Td style={{ textAlign: "center" }}>
                    <Text size="sm" c="red">{m.lost}</Text>
                  </Table.Td>
                  <Table.Td style={{ textAlign: "center" }}>
                    <Badge
                      variant="light"
                      color={convRate >= 10 ? "green" : convRate >= 5 ? "yellow" : "gray"}
                      size="sm"
                    >
                      {convRate}%
                    </Badge>
                  </Table.Td>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
          <Table.Tfoot>
            <Table.Tr>
              <Table.Td>
                <Text size="sm" fw={700}>TOTAL</Text>
              </Table.Td>
              <Table.Td style={{ textAlign: "center" }}>
                <Text size="sm" fw={700}>{totals.newLeads}</Text>
              </Table.Td>
              <Table.Td style={{ textAlign: "center" }}>
                <Text size="sm" fw={700} c="green">{totals.converted}</Text>
              </Table.Td>
              <Table.Td style={{ textAlign: "center" }}>
                <Text size="sm" fw={700} c="red">{totals.lost}</Text>
              </Table.Td>
              <Table.Td style={{ textAlign: "center" }}>
                <Badge variant="light" color="blue" size="sm">
                  {totals.newLeads > 0
                    ? Math.round((totals.converted / totals.newLeads) * 1000) / 10
                    : 0}%
                </Badge>
              </Table.Td>
            </Table.Tr>
          </Table.Tfoot>
        </Table>
      </Stack>
    </Paper>
  );
}
